import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./ClientLayout.scss";
import "../../ClientSideNavBar/ClientSideNavbar.scss";
import React, { useEffect, useState } from "react";
import { ClientTopBar } from "./ClientTopBar";
import { Box } from "@mui/material";
import { ClientSideNavBar } from "../../ClientSideNavBar/ClientSideNavbar";
import ContractApi from "../../../../infrastructure/api/pages/contract-api";
import { PortalContractUnavailable } from "./PortalContractUnavailable";
export const ClientLayout = ({ children, page, }) => {
    const contractId = new URLSearchParams(window.location.search).get("contractId");
    // Guards every step wrapped by this layout - roof-access, billing-address,
    // checking-and-paying and completion - against being opened for a contract the customer has
    // already rejected. They are public routes, so hiding the buttons on one page did not stop the
    // rest being reached by URL or back button. The backend refuses these writes independently; this
    // is the matching UX so the customer sees why rather than a form that silently fails.
    const [contractRejected, setContractRejected] = useState(false);
    useEffect(() => {
        if (!contractId) {
            return;
        }
        let cancelled = false;
        ContractApi.getById(contractId)
            .then((response) => {
            var _a;
            // Only a confirmed rejection blocks the page. A failed request is left alone on purpose:
            // the API returns 500 for both "not found" and a transient error, so treating failure as
            // "unavailable" would take the portal down on a network blip.
            if (!cancelled && response.status === 200 && ((_a = response.data) === null || _a === void 0 ? void 0 : _a.isDeleted) === true) {
                setContractRejected(true);
            }
        })
            .catch(() => { });
        return () => {
            cancelled = true;
        };
    }, [contractId]);
    return (_jsxs(Box, { className: "clientlayoutcontainer", sx: {
            padding: { xs: 2, sm: 3, md: 4 },
            paddingBottom: { xs: 10 }
        }, children: [_jsx(Box, { className: "topbar", children: _jsx(ClientTopBar, {}) }), _jsxs(Box, { className: "maingrid", sx: {
                    gap: { xs: 1, sm: 1, md: 2, lg: 4 },
                    flexDirection: { xs: "column", sm: "column", md: "row" }
                }, children: [_jsx(ClientSideNavBar, { page: page }), _jsx(Box, { className: "content-grid", sx: { width: "100%", height: "100%", position: "relative" }, children: contractRejected ? _jsx(PortalContractUnavailable, {}) : children })] })] }));
};
